import React from 'react';
import { DollarSign, Calculator, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
export function HowItWorks() {
  const {
    language
  } = useLanguage();
  const t = translations[language].howItWorks;
  const steps = [{
    icon: DollarSign,
    title: t.step1Title,
    description: t.step1Desc
  }, {
    icon: Calculator,
    title: t.step2Title,
    description: t.step2Desc
  }, {
    icon: Award,
    title: t.step3Title,
    description: t.step3Desc
  }];
  return <section id="how-it-works" className="py-16 sm:py-24 bg-gray-50" data-id="element-140">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="text-center mb-16" data-id="element-142">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900" data-id="element-143">
            {t.title}
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-144">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-145">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-146">
              <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200 h-full" data-id="element-147">
                <div className="w-14 h-14 bg-gray-900 rounded-xl flex items-center justify-center mb-6" data-id="element-148">
                  <step.icon className="w-7 h-7 text-white" data-id="element-149" />
                </div>
                <div className="absolute top-8 left-8 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold -translate-x-1/2 -translate-y-1/2" data-id="element-150">
                  {index + 1}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-151">
                  {step.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-152">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gray-300" data-id="element-153" />}
            </div>)}
        </div>
      </div>
    </section>;
}